import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { palette, gradients, focusRing } from './designTokens';

const PrimaryButton = ({ children, loader, startIcon, endIcon, onClick, disabled, sx = {}, size = 'medium', type }) => {
  return (
    <Button
      type={type}
      onClick={onClick}
      disabled={disabled || loader}
      startIcon={!loader && startIcon}
      endIcon={!loader && endIcon}
      size={size}
      sx={{
        textTransform: 'none',
        fontWeight: 700,
        fontSize: 14,
        // A label is one phrase, never two stacked lines: "Add product"
        // breaking into "Add / product" reads as two controls.
        whiteSpace: 'nowrap',
        flexShrink: 0,
        px: 2.25, py: 0.875,
        borderRadius: '10px',
        background: gradients.brand,
        color: '#fff',
        boxShadow: '0 6px 14px rgba(241, 73, 80, 0.22)',
        '&:hover': {
          background: palette.brandDark,
          boxShadow: '0 8px 18px rgba(241, 73, 80, 0.32)',
        },
        '&:focus-visible': focusRing,
        '&:disabled': {
          background: palette.line,
          color: palette.hint,
          boxShadow: 'none',
        },
        ...sx,
      }}
    >
      {loader ? <CircularProgress size={18} color="inherit" /> : children}
    </Button>
  );
};

export const SecondaryButton = ({ children, startIcon, endIcon, onClick, disabled, sx = {}, size = 'medium' }) => (
  <Button
    onClick={onClick}
    disabled={disabled}
    startIcon={startIcon}
    endIcon={endIcon}
    size={size}
    sx={{
      textTransform: 'none',
      fontWeight: 600,
      fontSize: 14,
      whiteSpace: 'nowrap',
      flexShrink: 0,
      px: 2, py: 0.75,
      borderRadius: '10px',
      bgcolor: '#fff',
      color: palette.inkSoft,
      border: `1px solid ${palette.line}`,
      '&:hover': {
        bgcolor: palette.surfaceAlt,
        borderColor: palette.muted,
      },
      '&:focus-visible': focusRing,
      ...sx,
    }}
  >
    {children}
  </Button>
);

export default PrimaryButton;
